// extracted by mini-css-extract-plugin
export var alertIcon = "_sx-0";